// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --icon-vk: #07f;
    --icon-vk-hover: #006be5;
    --icon-youtube: red;
    --icon-youtube-hover: #e50000;
    --icon-discord: #5865f2;
    --icon-discord-hover: #4856f0;
    --color-accent: #0af;
    --color-background: white;
    --stroke-width: calc(1em / 16);
    --font-size: 10vmin;
    --font-weight: 700;
    --letter-spacing: calc(1em / 8);
    --max_width_roulete: 999px;
    --min_height_roulete: 600px;
}

body {
    color: #0f1721;
}

.Roulete_snakes_mainCotainerRoulete__H-Mtu {
    display: flex;
    flex-direction: column;

    color: whitesmoke;

    min-height: 100vh;
    font-family: Popins, sans-serif;
    padding: 0 20px;
}

.Roulete_snakes_containerGame__ZoO5f {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    /* Центрируем контейнер с ячейками по горизонтали */
    flex-direction: column;
    align-items: center;
    /* Центрируем контейнер с ячейками по вертикали */
    gap: 20px;
}

.Roulete_snakes_containerBetsInfInGame__ra2a\\+ {

    position: absolute;
    top: 70px;
    right: 10px;

    z-index: 100000;
}

.Roulete_snakes_wrapperContentGame__5uV3M {
    display: flex;
    flex-direction: row;
    background-color: #242c54;
    border-radius: 10px;
    flex-flow: row-reverse;
    position: relative;
}

.Roulete_snakes_wrapperInfGame__uNKUf {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    order: 2;
}

@keyframes Roulete_snakes_ApperAnimate__0QCMy {
    0% {
        opacity: 0;

    }

    100% {
        opacity: 1;

    }
}

.Roulete_snakes_main__1a3l5 {
    margin-top: 4rem;

    display: flex;
    flex-direction: row;
    justify-content: space-between;


}

.Roulete_snakes_mainGame__Lx4RK {

    z-index: 1000;
    /* establish flex container */

    display: flex;
    flex-direction: column;
    /* default value; can be omitted */
    flex-wrap: nowrap;
    /* default value; can be omitted */
    min-height: 100svh;

}

.Roulete_snakes_containerInfGame__o2XDV {
    display: flex;
    flex-direction: row;
    justify-content: center;


}

.Roulete_snakes_wrapperSwitcher__ibgAk {

    display: flex;
    justify-content: center;
    align-items: center;
    /* Выравнивает элементы по центру по вертикали */
}

.Roulete_snakes_containerDemoBil__4BHen {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 20%;
    padding: 1rem;
    height: 30px;
    background-color: #242c54;

    border-radius: 3rem;
    animation: Roulete_snakes_ApperAnimate__0QCMy 1.5s ease-in-out;
    animation-fill-mode: forwards;
}

.Roulete_snakes_containerDemoBil__4BHen span {
    color: greenyellow;
    font-family: Poppins, sans-serif;
    font-size: 20px;
}

.Roulete_snakes_containerSwitcher__6yCRV {
    display: flex;
    margin-right: 10px;
}

.Roulete_snakes_timerContainer__bfn6J {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    margin-left: 10px;
    display: flex;
    justify-content: left;
    align-items: center;
    flex-direction: row;
    gap: 0.5rem;
    order: 1;


}

.Roulete_snakes_containerFirstGameInf__8o0sT {
    display: flex;
    flex-direction: row;
}

.Roulete_snakes_containerFirstGameInf__8o0sT .Roulete_snakes_inGame__IT7zn {
    flex-direction: column;
}

.Roulete_snakes_textContainer__FMhY1 {
    font-size: 30px;
    color: whitesmoke;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
    /*margin-top: 20px; !* Регулируйте, чтобы создать желаемый отступ между текстом и таймером *!*/
}

.Roulete_snakes_downLast10__JltPJ {
    max-width: 450px;
    max-height: 150px;
    display: none;
    margin: 0 auto;
    padding: 5px;

}

.Roulete_snakes_upLast10__KrXRW {
    max-width: 150px;
    max-height: 450px;
    display: flex;
    padding: 10px;

}

.Roulete_snakes_containerInfLast10__lM9yN {



    flex-direction: column;
    background-color: #181c3d;

    order: 2;
    font-size: 10px;



    border-radius: 10px;
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
}

.Roulete_snakes_disable__4p7Uc {
    display: none !important;
}

.Roulete_snakes_containerLast__X3i-G {
    
    transition: opacity 1s;
    
    text-align: center;

    display: flex;
    z-index: 10;
    gap: 5px;
    background-color: rgba(17,23,32,.75);
    padding: 10px;
    border-radius: 10px;


}
.Roulete_snakes_containerTop__zk97G{
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    bottom:10px;
    left: calc(30%);
    transition: opacity 1s;
    
    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    
    background-color: rgba(17,23,32,.75);
    padding: 5px;
    border-radius: 10px;
}
.Roulete_snakes_headerTop__O7kzg{
    display: flex;
    
    color:white;
    align-items: center;
    font-family: Popins,sans-serif;
    text-shadow: none;
    font-size: 20px;
}
.Roulete_snakes_blockLast10__aW7SH {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    border-radius: 10px;
    font-size: 15px;
    color: white;
    font-family: Popins, sans-serif;
    font-weight: 400!important;
    text-shadow: none;
}

.Roulete_snakes_containerInfTopFive__ej\\+X2 {
    width: 150px;
    height: 250px;
    background-color: #181c3d;
    display: flex;
    font-size: 25px;

    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
    font-family: "Montserrat", sans-serif;
    font-weight: 500;


}

.Roulete_snakes_topBlock__Psrei .Roulete_snakes_block__6BRQ3 {
    border-spacing: 0;
    border-collapse: collapse;
    width: 35px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    font-size: 25px;
    color: white;
    white-space: nowrap;
    border-radius: 5px;
}

.Roulete_snakes_containerInfLast10__lM9yN .Roulete_snakes_header__8Qfou {
    display: flex;
    justify-content: center;

    text-align: center;
    color: whitesmoke;
    font-size: 20px;
    margin: 0 auto;
    margin-bottom: 10px;
}

.Roulete_snakes_containerInfTopFive__ej\\+X2 .Roulete_snakes_header__8Qfou {
    display: flex;
    justify-content: center;

    text-align: center;
    color: whitesmoke;
    font-size: 25px;
    margin: 0 auto;
    margin-bottom: 10px;
}

.Roulete_snakes_topContainer__dA0SE {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.Roulete_snakes_downLast10__JltPJ .Roulete_snakes_topContainer__dA0SE {
    flex-direction: row;
}

.Roulete_snakes_topContainer__dA0SE .Roulete_snakes_textInf__0uo-- {
    color: white;
}

.Roulete_snakes_topBlock__Psrei {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.Roulete_snakes_containerTable__PHAQk {

    display: flex;
    order: 1;
    flex-direction: column;
    max-width: 500px;

    gap: 1rem;
    padding: 20px;
    border-right: 1px solid #ffffff30;
    /* Добавляем красную линию справа */

}

.Roulete_snakes_button__RuUQk {
    display: flex;
    justify-content: center;
}

.Roulete_snakes_containerRoulete__g63sV {
    /*margin-top: 30px;*/
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 1rem;
    flex-wrap: wrap;

    border-radius: 3rem;
    padding: 1rem
}

.Roulete_snakes_containerHeaderGame__RC9ff {
    display: flex;
    justify-content: space-between;
    gap: 20px;

}

.Roulete_snakes_no_bets__5zj8g {
    margin-top: 10px;
    display: flex;
    margin-right: 30px;

    justify-content: right;
    order: 4;
    font-size: 20px;
    color: white;
    font-family: Gilroy, sans-serif;
    font-weight: 700;
}

.Roulete_snakes_containerBetsInf__SLMTq {
    margin-top: 10px;
    margin-right: 20px;

    margin-bottom: 10px;
    display: flex;

    flex-direction: column;
    gap: 0.5em;
   
}

.Roulete_snakes_containerBetInGame__8U3oD {
    display: flex;
    flex-direction: row;
    order: 2;
    width: 100%;
    justify-content: left;
    align-items: center;
    height: 50px;
    gap: 1.5rem;
    background-color: #3546988d;
    border-radius: 3rem;
    padding: 1rem;

    animation: Roulete_snakes_ApperAnimate__0QCMy 1.5s ease-in-out;
    animation-fill-mode: forwards;
    margin-bottom: 10px;
}

.Roulete_snakes_containerBetInGameSuccses__tFaz- {
    display: flex;
    flex-direction: row;
    order: 2;
    width: 100%;
    justify-content: left;
    align-items: center;
    height: 50px;
    gap: 1.5rem;
    background: linear-gradient(45deg, #ff8c00, #ffa500);
    border-radius: 3rem;
    padding: 1rem;
    animation: Roulete_snakes_ApperAnimate__0QCMy 1.5s ease-in-out;
    animation-fill-mode: forwards;
    margin-bottom: 10px;
}

.Roulete_snakes_containerBetInGameSuccses__tFaz-::before {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
    transform: skewX(-15deg);
    animation: Roulete_snakes_shiny-animation__htRFn 1s infinite;
}

@keyframes Roulete_snakes_shiny-animation__htRFn {
    0% {
        left: -150%;
    }

    50% {
        left: 100%;
    }

    100% {
        left: 100%;
    }
}

.Roulete_snakes_containerBetInGame__8U3oD.Roulete_snakes_succses__lDSbI {
    background-color: greenyellow;

}

.Roulete_snakes_containerBet__iqKXa {

    display: flex;
    flex-direction: row;
    
    width: 100%;
    justify-content: left;
    align-items: center;
    height: 50px;
    gap: 1.5rem;
    background-color: #354698;
    border-radius: 3rem;
    padding: 1rem;
    animation: Roulete_snakes_ApperAnimate__0QCMy 1.5s ease-in-out;
    animation-fill-mode: forwards;

}

.Roulete_snakes_betsAmountInf__NFYOQ {
    color: greenyellow;
    font-size: 20px;
    font-family: Gilroy, sans-serif;
    font-weight: 600;
}

.Roulete_snakes_btnCancel__6m4Si {
    background-color: red;
}

.Roulete_snakes_choice_container__YM-gE {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.Roulete_snakes_imgContainer__dp9Fb {
    margin-top: 1rem;

    display: flex;


    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
}

.Roulete_snakes_imgContainer__dp9Fb img {
    width: 100%;
    height: auto;
    /* Сохраняем пропорции изображения */
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
    pointer-events: none;
    /* Отключение взаимодействия с изображением */

}

.Roulete_snakes_img__HL-mR .Roulete_snakes_selected__s2itX {
    opacity: 1;
}


.Roulete_snakes_opac_lite__lpZdk {
    opacity: 0.7;
}

.Roulete_snakes_opac__3meKz {
    opacity: 0.1;
}

@keyframes Roulete_snakes_pulse__ISuqt {
    0% {
        font-size: 20px;
    }

    50% {
        font-size: 30px;
    }

    100% {
        font-size: 20px;
    }
}

.Roulete_snakes_text_block__2agrl {
    z-index: 1000;
    width: 100%;
    display: flex;

    margin-top: 30px;
    justify-content: center;
    font-family: "Gilroy", sans-serif;
    font-weight: 600;
    color: #053fc7;
    animation: Roulete_snakes_pulse__ISuqt 2s infinite alternate;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
}

.Roulete_snakes_blockButtonCancel__\\+uNq6 {
    font-size: 28px;
    color: red;
    cursor: pointer;
    margin-left: auto;
    /* Это свойство поместит блок .blockButtonCancel в конец контейнера */


}

.Roulete_snakes_btnCancel__6m4Si {
    width: 50px;
    height: 50px;
    box-shadow: 0px 10 10px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    background: red;
    cursor: pointer;

    position: absolute;
    display: block;
    z-index: 200;
    text-indent: -9999px;
}

.Roulete_snakes_btnCancel__6m4Si:before,
.Roulete_snakes_btnCancel__6m4Si:after {
    content: '';
    width: 55%;
    height: 2px;
    background: #fff;
    position: absolute;
    top: 48%;
    left: 22%;
    transform: rotate(-45deg);
    transition: all 0.3s ease-out;
}

.Roulete_snakes_btnCancel__6m4Si:after {
    transform: rotate(45deg);
    transition: all 0.3s ease-out;
}

.Roulete_snakes_nameBet__JZFb8 {
    color: white;
    font-size: 20px;
    font-family: 'Poppins', sans-serif;
}

.Roulete_snakes_btnCancel__6m4Si:hover:before,
.Roulete_snakes_btnCancel__6m4Si:hover:after {
    transform: rotate(180deg);
}

.Roulete_snakes_containerBtnBet__WEx2N {
    display: flex;
    justify-content: center;
    align-items: center;
}


/*.game_field{*/
/*    display: flex;*/
/*    justify-content: left;*/

/*    order: 1;*/
/*    width: 800px;*/
/*    height: 800px;*/
/*    !*border: 1px green solid;*!*/
/*}*/
/*.UI{*/
/*    display: flex;*/
/*    justify-content: right;*/
/*    order: 2;*/
/*    width: 500px;*/
/*    height: 500px;*/
/*    !*border: 1px red solid;*!*/
/*}*/
@media (max-width: 1000px) {
    .Roulete_snakes_containerTable__PHAQk {
        width: 80%;
        margin-top: 0;
        order: 3;
        margin-bottom: 50px;
    }

    .Roulete_snakes_main__1a3l5 {
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
    }

    .Roulete_snakes_no_bets__5zj8g {
        margin-right: 0;

        

    }

    .Roulete_snakes_containerBetsInf__SLMTq {
        margin-top: 0;
        margin-right: 0;
        margin-bottom: 5px;
        gap: 0.5rem;
        
    }

    .Roulete_snakes_containerInfGame__o2XDV {
        width: 100%;
    }






}

@media screen and (max-width: 1000px) {
    .Roulete_snakes_containerTable__PHAQk {
        width: 100%;
        height: 30%;
    }

    .Roulete_snakes_choice_container__YM-gE {
        margin-top: 0;
    }

    .Roulete_snakes_imgContainer__dp9Fb {
        margin-top: 0;
    }



}

.Roulete_snakes_contCenter__rlcTK {
    display: flex;
    justify-content: center;
    align-items: center;
}


@media screen and (max-width: 1000px) {

    .Roulete_snakes_main__1a3l5 {
        margin-left: 0;
    }

    .Roulete_snakes_mainGame__Lx4RK {
        margin-top: 4rem;
        margin-left: 0;
    }

}

.Roulete_snakes_wrapperBetsInf__PPTC3 {

    display: flex;
    justify-content: center;
}

@media only screen and (max-width: 1300px) {
    .Roulete_snakes_downLast10__JltPJ {
        display: flex;
    }

    .Roulete_snakes_upLast10__KrXRW {
        display: none;
    }

    .Roulete_snakes_containerRoulete__g63sV {
        flex-direction: column;

    }

    .Roulete_snakes_containerBetsInf__SLMTq {
        margin-left: 0;
    }

}

@media only screen and (max-width: 1000px) {
    .Roulete_snakes_containerTable__PHAQk {
        width: 100%;
        padding: 10px 0 10px 0;
        justify-content: center;
        align-items: center;
        order: 2;
        border-top: 1px solid #ffffff30;
        /* Добавляем красную линию справа */

        border-right: 0;


    }

    .Roulete_snakes_blockHistoryButton__wFW-l {
        position: relative;
        display: flex;
        justify-content: flex-end;
    }

    .Roulete_snakes_button__RuUQk,
    .Roulete_snakes_containerMines__GAb23 {
        width: 90%;
    }

    h1 {
        margin: 0 0 0.5rem;
    }

    .Roulete_snakes_mainCotainerRoulete__H-Mtu {
        padding: 0 5px;
    }

    .Roulete_snakes_containerGame__ZoO5f {
        order: 1;

        padding-bottom: 0;
    }

    .Roulete_snakes_wrapperContentGame__5uV3M {
        margin: 0;
        margin-top: 60px;
        flex-direction: column;

    }

    .Roulete_snakes_containerNamingsGame__ACa-k {
        margin-top: 70px;
        padding: 0 10px;
    }

    .Roulete_snakes_mainCotainerRoulete__H-Mtu {
        margin-left: 0;
    }

    .Roulete_snakes_containerBets__Fkg1y {
        gap: 2px;
        margin-bottom: 50px;

    }

    .Roulete_snakes_containerBet__iqKXa {
        gap: 15px;
    }

    .Roulete_snakes_containerBetInGame__8U3oD {
        flex-basis: calc(100% - 0.5rem);
    }

    .Roulete_snakes_containerBetInGameSuccses__tFaz- {
        flex-basis: calc(100% - 0.5rem);
    }

    .Roulete_snakes_bet_container__pFRfZ {
        width: 90%;
    }

}

.Roulete_snakes_containerTableBets__a4lAS {
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Roulete_snakes/index.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;IACpB,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,iBAAiB;;IAEjB,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mDAAmD;IACnD,sBAAsB;IACtB,mBAAmB;IACnB,iDAAiD;IACjD,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,WAAW;;IAEX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI;QACI,UAAU;;IAEd;;IAEA;QACI,UAAU;;IAEd;AACJ;;AAEA;IACI,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;;AAGlC;;AAEA;;IAEI,aAAa;IACb,6BAA6B;;IAE7B,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,YAAY;IACZ,yBAAyB;;IAEzB,mBAAmB;IACnB,8DAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,QAAQ;;;AAGZ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;IACjB,8FAA8F;AAClG;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,aAAa;;AAEjB;;AAEA;;;;IAII,sBAAsB;IACtB,yBAAyB;;IAEzB,QAAQ;IACR,eAAe;;;;IAIf,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,sBAAsB;;IAEtB,kBAAkB;;IAElB,aAAa;IACb,WAAW;IACX,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,mBAAmB;;;AAGvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sBAAsB;;IAEtB,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;;IAEX,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;;IAEb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,eAAe;;IAEf,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;;;AAGpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;;IAEhB,SAAS;IACT,aAAa;IACb,iCAAiC;IACjC,mCAAmC;;AAEvC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;;IAEf,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;;AAEb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;;IAElB,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;;IAElB,mBAAmB;IACnB,aAAa;;IAEb,sBAAsB;IACtB,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;;IAEb,8DAAwC;IACxC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oDAAoD;IACpD,mBAAmB;IACnB,aAAa;IACb,8DAAwC;IACxC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,wBAAwB;IACxB,4DAAsC;AAC1C;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,6BAA6B;;AAEjC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,8DAAwC;IACxC,6BAA6B;;AAEjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;;IAEhB,aAAa;;;IAGb,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;IACpB,6CAA6C;;AAEjD;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;;IAEb,gBAAgB;IAChB,uBAAuB;IACvB,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,4DAAsC;IACtC,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,qEAAqE;;;AAGzE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gDAAgD;IAChD,mBAAmB;IACnB,eAAe;IACf,eAAe;;IAEf,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAKT,yBAAyB;IAKzB,6BAA6B;AACjC;;AAEA;IAKI,wBAAwB;IAKxB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kCAAkC;AACtC;;AAEA;;IAMI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA,eAAe;AACf,qBAAqB;AACrB,6BAA6B;;AAE7B,gBAAgB;AAChB,oBAAoB;AACpB,qBAAqB;AACrB,mCAAmC;AACnC,IAAI;AACJ,OAAO;AACP,qBAAqB;AACrB,8BAA8B;AAC9B,gBAAgB;AAChB,oBAAoB;AACpB,qBAAqB;AACrB,iCAAiC;AACjC,IAAI;AACJ;IACI;QACI,UAAU;QACV,aAAa;QACb,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,eAAe;;;;IAInB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,WAAW;;IAEf;;IAEA;QACI,WAAW;IACf;;;;;;;AAOJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;;;AAIJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;AAEJ;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;;IAE1B;;IAEA;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;QACR,+BAA+B;QAC/B,mCAAmC;;QAEnC,eAAe;;;IAGnB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,yBAAyB;IAC7B;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,QAAQ;;QAER,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,sBAAsB;;IAE1B;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,QAAQ;QACR,mBAAmB;;IAEvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ","sourcesContent":[":root {\n    --icon-vk: #07f;\n    --icon-vk-hover: #006be5;\n    --icon-youtube: red;\n    --icon-youtube-hover: #e50000;\n    --icon-discord: #5865f2;\n    --icon-discord-hover: #4856f0;\n    --color-accent: #0af;\n    --color-background: white;\n    --stroke-width: calc(1em / 16);\n    --font-size: 10vmin;\n    --font-weight: 700;\n    --letter-spacing: calc(1em / 8);\n    --max_width_roulete: 999px;\n    --min_height_roulete: 600px;\n}\n\nbody {\n    color: #0f1721;\n}\n\n.mainCotainerRoulete {\n    display: flex;\n    flex-direction: column;\n\n    color: whitesmoke;\n\n    min-height: 100vh;\n    font-family: Popins, sans-serif;\n    padding: 0 20px;\n}\n\n.containerGame {\n    position: relative;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    /* Центрируем контейнер с ячейками по горизонтали */\n    flex-direction: column;\n    align-items: center;\n    /* Центрируем контейнер с ячейками по вертикали */\n    gap: 20px;\n}\n\n.containerBetsInfInGame {\n\n    position: absolute;\n    top: 70px;\n    right: 10px;\n\n    z-index: 100000;\n}\n\n.wrapperContentGame {\n    display: flex;\n    flex-direction: row;\n    background-color: #242c54;\n    border-radius: 10px;\n    flex-flow: row-reverse;\n    position: relative;\n}\n\n.wrapperInfGame {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    order: 2;\n}\n\n@keyframes ApperAnimate {\n    0% {\n        opacity: 0;\n\n    }\n\n    100% {\n        opacity: 1;\n\n    }\n}\n\n.main {\n    margin-top: 4rem;\n\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n\n}\n\n.mainGame {\n\n    z-index: 1000;\n    /* establish flex container */\n\n    display: flex;\n    flex-direction: column;\n    /* default value; can be omitted */\n    flex-wrap: nowrap;\n    /* default value; can be omitted */\n    min-height: 100svh;\n\n}\n\n.containerInfGame {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n\n\n}\n\n.wrapperSwitcher {\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* Выравнивает элементы по центру по вертикали */\n}\n\n.containerDemoBil {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 20%;\n    padding: 1rem;\n    height: 30px;\n    background-color: #242c54;\n\n    border-radius: 3rem;\n    animation: ApperAnimate 1.5s ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n.containerDemoBil span {\n    color: greenyellow;\n    font-family: Poppins, sans-serif;\n    font-size: 20px;\n}\n\n.containerSwitcher {\n    display: flex;\n    margin-right: 10px;\n}\n\n.timerContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    margin-left: 10px;\n    display: flex;\n    justify-content: left;\n    align-items: center;\n    flex-direction: row;\n    gap: 0.5rem;\n    order: 1;\n\n\n}\n\n.containerFirstGameInf {\n    display: flex;\n    flex-direction: row;\n}\n\n.containerFirstGameInf .inGame {\n    flex-direction: column;\n}\n\n.textContainer {\n    font-size: 30px;\n    color: whitesmoke;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n    /*margin-top: 20px; !* Регулируйте, чтобы создать желаемый отступ между текстом и таймером *!*/\n}\n\n.downLast10 {\n    max-width: 450px;\n    max-height: 150px;\n    display: none;\n    margin: 0 auto;\n    padding: 5px;\n\n}\n\n.upLast10 {\n    max-width: 150px;\n    max-height: 450px;\n    display: flex;\n    padding: 10px;\n\n}\n\n.containerInfLast10 {\n\n\n\n    flex-direction: column;\n    background-color: #181c3d;\n\n    order: 2;\n    font-size: 10px;\n\n\n\n    border-radius: 10px;\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 500;\n}\n\n.disable {\n    display: none !important;\n}\n\n.containerLast {\n    \n    transition: opacity 1s;\n    \n    text-align: center;\n\n    display: flex;\n    z-index: 10;\n    gap: 5px;\n    background-color: rgba(17,23,32,.75);\n    padding: 10px;\n    border-radius: 10px;\n\n\n}\n.containerTop{\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    bottom:10px;\n    left: calc(30%);\n    transition: opacity 1s;\n    \n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 10;\n    \n    background-color: rgba(17,23,32,.75);\n    padding: 5px;\n    border-radius: 10px;\n}\n.headerTop{\n    display: flex;\n    \n    color:white;\n    align-items: center;\n    font-family: Popins,sans-serif;\n    text-shadow: none;\n    font-size: 20px;\n}\n.blockLast10 {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n    border-radius: 10px;\n    font-size: 15px;\n    color: white;\n    font-family: Popins, sans-serif;\n    font-weight: 400!important;\n    text-shadow: none;\n}\n\n.containerInfTopFive {\n    width: 150px;\n    height: 250px;\n    background-color: #181c3d;\n    display: flex;\n    font-size: 25px;\n\n    flex-direction: column;\n    padding: 10px;\n    border-radius: 10px;\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 500;\n\n\n}\n\n.topBlock .block {\n    border-spacing: 0;\n    border-collapse: collapse;\n    width: 35px;\n    height: 30px;\n    text-align: center;\n    vertical-align: middle;\n    font-size: 25px;\n    color: white;\n    white-space: nowrap;\n    border-radius: 5px;\n}\n\n.containerInfLast10 .header {\n    display: flex;\n    justify-content: center;\n\n    text-align: center;\n    color: whitesmoke;\n    font-size: 20px;\n    margin: 0 auto;\n    margin-bottom: 10px;\n}\n\n.containerInfTopFive .header {\n    display: flex;\n    justify-content: center;\n\n    text-align: center;\n    color: whitesmoke;\n    font-size: 25px;\n    margin: 0 auto;\n    margin-bottom: 10px;\n}\n\n.topContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.downLast10 .topContainer {\n    flex-direction: row;\n}\n\n.topContainer .textInf {\n    color: white;\n}\n\n.topBlock {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.containerTable {\n\n    display: flex;\n    order: 1;\n    flex-direction: column;\n    max-width: 500px;\n\n    gap: 1rem;\n    padding: 20px;\n    border-right: 1px solid #ffffff30;\n    /* Добавляем красную линию справа */\n\n}\n\n.button {\n    display: flex;\n    justify-content: center;\n}\n\n.containerRoulete {\n    /*margin-top: 30px;*/\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    gap: 1rem;\n    flex-wrap: wrap;\n\n    border-radius: 3rem;\n    padding: 1rem\n}\n\n.containerHeaderGame {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n\n}\n\n.no_bets {\n    margin-top: 10px;\n    display: flex;\n    margin-right: 30px;\n\n    justify-content: right;\n    order: 4;\n    font-size: 20px;\n    color: white;\n    font-family: Gilroy, sans-serif;\n    font-weight: 700;\n}\n\n.containerBetsInf {\n    margin-top: 10px;\n    margin-right: 20px;\n\n    margin-bottom: 10px;\n    display: flex;\n\n    flex-direction: column;\n    gap: 0.5em;\n   \n}\n\n.containerBetInGame {\n    display: flex;\n    flex-direction: row;\n    order: 2;\n    width: 100%;\n    justify-content: left;\n    align-items: center;\n    height: 50px;\n    gap: 1.5rem;\n    background-color: #3546988d;\n    border-radius: 3rem;\n    padding: 1rem;\n\n    animation: ApperAnimate 1.5s ease-in-out;\n    animation-fill-mode: forwards;\n    margin-bottom: 10px;\n}\n\n.containerBetInGameSuccses {\n    display: flex;\n    flex-direction: row;\n    order: 2;\n    width: 100%;\n    justify-content: left;\n    align-items: center;\n    height: 50px;\n    gap: 1.5rem;\n    background: linear-gradient(45deg, #ff8c00, #ffa500);\n    border-radius: 3rem;\n    padding: 1rem;\n    animation: ApperAnimate 1.5s ease-in-out;\n    animation-fill-mode: forwards;\n    margin-bottom: 10px;\n}\n\n.containerBetInGameSuccses::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -150%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n    transform: skewX(-15deg);\n    animation: shiny-animation 1s infinite;\n}\n\n@keyframes shiny-animation {\n    0% {\n        left: -150%;\n    }\n\n    50% {\n        left: 100%;\n    }\n\n    100% {\n        left: 100%;\n    }\n}\n\n.containerBetInGame.succses {\n    background-color: greenyellow;\n\n}\n\n.containerBet {\n\n    display: flex;\n    flex-direction: row;\n    \n    width: 100%;\n    justify-content: left;\n    align-items: center;\n    height: 50px;\n    gap: 1.5rem;\n    background-color: #354698;\n    border-radius: 3rem;\n    padding: 1rem;\n    animation: ApperAnimate 1.5s ease-in-out;\n    animation-fill-mode: forwards;\n\n}\n\n.betsAmountInf {\n    color: greenyellow;\n    font-size: 20px;\n    font-family: Gilroy, sans-serif;\n    font-weight: 600;\n}\n\n.btnCancel {\n    background-color: red;\n}\n\n.choice_container {\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.imgContainer {\n    margin-top: 1rem;\n\n    display: flex;\n\n\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n.imgContainer img {\n    width: 100%;\n    height: auto;\n    /* Сохраняем пропорции изображения */\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n    pointer-events: none;\n    /* Отключение взаимодействия с изображением */\n\n}\n\n.img .selected {\n    opacity: 1;\n}\n\n\n.opac_lite {\n    opacity: 0.7;\n}\n\n.opac {\n    opacity: 0.1;\n}\n\n@keyframes pulse {\n    0% {\n        font-size: 20px;\n    }\n\n    50% {\n        font-size: 30px;\n    }\n\n    100% {\n        font-size: 20px;\n    }\n}\n\n.text_block {\n    z-index: 1000;\n    width: 100%;\n    display: flex;\n\n    margin-top: 30px;\n    justify-content: center;\n    font-family: \"Gilroy\", sans-serif;\n    font-weight: 600;\n    color: #053fc7;\n    animation: pulse 2s infinite alternate;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n.blockButtonCancel {\n    font-size: 28px;\n    color: red;\n    cursor: pointer;\n    margin-left: auto;\n    /* Это свойство поместит блок .blockButtonCancel в конец контейнера */\n\n\n}\n\n.btnCancel {\n    width: 50px;\n    height: 50px;\n    box-shadow: 0px 10 10px 10px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    background: red;\n    cursor: pointer;\n\n    position: absolute;\n    display: block;\n    z-index: 200;\n    text-indent: -9999px;\n}\n\n.btnCancel:before,\n.btnCancel:after {\n    content: '';\n    width: 55%;\n    height: 2px;\n    background: #fff;\n    position: absolute;\n    top: 48%;\n    left: 22%;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.btnCancel:after {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.nameBet {\n    color: white;\n    font-size: 20px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.btnCancel:hover:before,\n.btnCancel:hover:after {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n.containerBtnBet {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n/*.game_field{*/\n/*    display: flex;*/\n/*    justify-content: left;*/\n\n/*    order: 1;*/\n/*    width: 800px;*/\n/*    height: 800px;*/\n/*    !*border: 1px green solid;*!*/\n/*}*/\n/*.UI{*/\n/*    display: flex;*/\n/*    justify-content: right;*/\n/*    order: 2;*/\n/*    width: 500px;*/\n/*    height: 500px;*/\n/*    !*border: 1px red solid;*!*/\n/*}*/\n@media (max-width: 1000px) {\n    .containerTable {\n        width: 80%;\n        margin-top: 0;\n        order: 3;\n        margin-bottom: 50px;\n    }\n\n    .main {\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        gap: 0.5rem;\n    }\n\n    .no_bets {\n        margin-right: 0;\n\n        \n\n    }\n\n    .containerBetsInf {\n        margin-top: 0;\n        margin-right: 0;\n        margin-bottom: 5px;\n        gap: 0.5rem;\n        \n    }\n\n    .containerInfGame {\n        width: 100%;\n    }\n\n\n\n\n\n\n}\n\n@media screen and (max-width: 1000px) {\n    .containerTable {\n        width: 100%;\n        height: 30%;\n    }\n\n    .choice_container {\n        margin-top: 0;\n    }\n\n    .imgContainer {\n        margin-top: 0;\n    }\n\n\n\n}\n\n.contCenter {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n@media screen and (max-width: 1000px) {\n\n    .main {\n        margin-left: 0;\n    }\n\n    .mainGame {\n        margin-top: 4rem;\n        margin-left: 0;\n    }\n\n}\n\n.wrapperBetsInf {\n\n    display: flex;\n    justify-content: center;\n}\n\n@media only screen and (max-width: 1300px) {\n    .downLast10 {\n        display: flex;\n    }\n\n    .upLast10 {\n        display: none;\n    }\n\n    .containerRoulete {\n        flex-direction: column;\n\n    }\n\n    .containerBetsInf {\n        margin-left: 0;\n    }\n\n}\n\n@media only screen and (max-width: 1000px) {\n    .containerTable {\n        width: 100%;\n        padding: 10px 0 10px 0;\n        justify-content: center;\n        align-items: center;\n        order: 2;\n        border-top: 1px solid #ffffff30;\n        /* Добавляем красную линию справа */\n\n        border-right: 0;\n\n\n    }\n\n    .blockHistoryButton {\n        position: relative;\n        display: flex;\n        justify-content: flex-end;\n    }\n\n    .button,\n    .containerMines {\n        width: 90%;\n    }\n\n    h1 {\n        margin: 0 0 0.5rem;\n    }\n\n    .mainCotainerRoulete {\n        padding: 0 5px;\n    }\n\n    .containerGame {\n        order: 1;\n\n        padding-bottom: 0;\n    }\n\n    .wrapperContentGame {\n        margin: 0;\n        margin-top: 60px;\n        flex-direction: column;\n\n    }\n\n    .containerNamingsGame {\n        margin-top: 70px;\n        padding: 0 10px;\n    }\n\n    .mainCotainerRoulete {\n        margin-left: 0;\n    }\n\n    .containerBets {\n        gap: 2px;\n        margin-bottom: 50px;\n\n    }\n\n    .containerBet {\n        gap: 15px;\n    }\n\n    .containerBetInGame {\n        flex-basis: calc(100% - 0.5rem);\n    }\n\n    .containerBetInGameSuccses {\n        flex-basis: calc(100% - 0.5rem);\n    }\n\n    .bet_container {\n        width: 90%;\n    }\n\n}\n\n.containerTableBets {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    order: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCotainerRoulete": `Roulete_snakes_mainCotainerRoulete__H-Mtu`,
	"containerGame": `Roulete_snakes_containerGame__ZoO5f`,
	"containerBetsInfInGame": `Roulete_snakes_containerBetsInfInGame__ra2a+`,
	"wrapperContentGame": `Roulete_snakes_wrapperContentGame__5uV3M`,
	"wrapperInfGame": `Roulete_snakes_wrapperInfGame__uNKUf`,
	"main": `Roulete_snakes_main__1a3l5`,
	"mainGame": `Roulete_snakes_mainGame__Lx4RK`,
	"containerInfGame": `Roulete_snakes_containerInfGame__o2XDV`,
	"wrapperSwitcher": `Roulete_snakes_wrapperSwitcher__ibgAk`,
	"containerDemoBil": `Roulete_snakes_containerDemoBil__4BHen`,
	"ApperAnimate": `Roulete_snakes_ApperAnimate__0QCMy`,
	"containerSwitcher": `Roulete_snakes_containerSwitcher__6yCRV`,
	"timerContainer": `Roulete_snakes_timerContainer__bfn6J`,
	"containerFirstGameInf": `Roulete_snakes_containerFirstGameInf__8o0sT`,
	"inGame": `Roulete_snakes_inGame__IT7zn`,
	"textContainer": `Roulete_snakes_textContainer__FMhY1`,
	"downLast10": `Roulete_snakes_downLast10__JltPJ`,
	"upLast10": `Roulete_snakes_upLast10__KrXRW`,
	"containerInfLast10": `Roulete_snakes_containerInfLast10__lM9yN`,
	"disable": `Roulete_snakes_disable__4p7Uc`,
	"containerLast": `Roulete_snakes_containerLast__X3i-G`,
	"containerTop": `Roulete_snakes_containerTop__zk97G`,
	"headerTop": `Roulete_snakes_headerTop__O7kzg`,
	"blockLast10": `Roulete_snakes_blockLast10__aW7SH`,
	"containerInfTopFive": `Roulete_snakes_containerInfTopFive__ej+X2`,
	"topBlock": `Roulete_snakes_topBlock__Psrei`,
	"block": `Roulete_snakes_block__6BRQ3`,
	"header": `Roulete_snakes_header__8Qfou`,
	"topContainer": `Roulete_snakes_topContainer__dA0SE`,
	"textInf": `Roulete_snakes_textInf__0uo--`,
	"containerTable": `Roulete_snakes_containerTable__PHAQk`,
	"button": `Roulete_snakes_button__RuUQk`,
	"containerRoulete": `Roulete_snakes_containerRoulete__g63sV`,
	"containerHeaderGame": `Roulete_snakes_containerHeaderGame__RC9ff`,
	"no_bets": `Roulete_snakes_no_bets__5zj8g`,
	"containerBetsInf": `Roulete_snakes_containerBetsInf__SLMTq`,
	"containerBetInGame": `Roulete_snakes_containerBetInGame__8U3oD`,
	"containerBetInGameSuccses": `Roulete_snakes_containerBetInGameSuccses__tFaz-`,
	"shiny-animation": `Roulete_snakes_shiny-animation__htRFn`,
	"succses": `Roulete_snakes_succses__lDSbI`,
	"containerBet": `Roulete_snakes_containerBet__iqKXa`,
	"betsAmountInf": `Roulete_snakes_betsAmountInf__NFYOQ`,
	"btnCancel": `Roulete_snakes_btnCancel__6m4Si`,
	"choice_container": `Roulete_snakes_choice_container__YM-gE`,
	"imgContainer": `Roulete_snakes_imgContainer__dp9Fb`,
	"img": `Roulete_snakes_img__HL-mR`,
	"selected": `Roulete_snakes_selected__s2itX`,
	"opac_lite": `Roulete_snakes_opac_lite__lpZdk`,
	"opac": `Roulete_snakes_opac__3meKz`,
	"text_block": `Roulete_snakes_text_block__2agrl`,
	"pulse": `Roulete_snakes_pulse__ISuqt`,
	"blockButtonCancel": `Roulete_snakes_blockButtonCancel__+uNq6`,
	"nameBet": `Roulete_snakes_nameBet__JZFb8`,
	"containerBtnBet": `Roulete_snakes_containerBtnBet__WEx2N`,
	"contCenter": `Roulete_snakes_contCenter__rlcTK`,
	"wrapperBetsInf": `Roulete_snakes_wrapperBetsInf__PPTC3`,
	"blockHistoryButton": `Roulete_snakes_blockHistoryButton__wFW-l`,
	"containerMines": `Roulete_snakes_containerMines__GAb23`,
	"containerNamingsGame": `Roulete_snakes_containerNamingsGame__ACa-k`,
	"containerBets": `Roulete_snakes_containerBets__Fkg1y`,
	"bet_container": `Roulete_snakes_bet_container__pFRfZ`,
	"containerTableBets": `Roulete_snakes_containerTableBets__a4lAS`
};
export default ___CSS_LOADER_EXPORT___;
